/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
import { sendDataLayer } from "jiffy-analytics";
import { isTouchDevice, isReplaceShirtPage } from "common/utils/browser";
import { cacheDeliveryEstimate } from "components/jiffy/product-details/cache-composition-delivery-date";
import initQtyPricingPopover from "components/jiffy/product-card/quantity-price-popover/quantity-price-popover";
import "components/jiffy/product-details-dtf-sheet/product-details-dtf-amounts/product-details-dtf-amounts.scss";
import "./product-card.scss";

const SELECTORS = {
  CARD: ".js-product-card",
  HEART: ".product-card__has-favorite",
  SHIPPER: ".js-ships",
  DESIGN_LAB_CTA_BUTTON: ".js-plp-design-lab-cta-button",
  QTY_PRICING_POPOVER: ".js-qty-pricing-popover"
};

const displayFavorites = productCard => {
  if (!window.favorite_composition_ids) return;

  const { compositionId, businessLine } = productCard.dataset;
  const compositionIdInt = parseInt(compositionId, 10);

  // Determine which business line favorites to check
  // Determine business line key
  const normalizedBusinessLine = businessLine?.toLowerCase();
  const businessLineKey = ["print", "dtf"].includes(normalizedBusinessLine)
    ? normalizedBusinessLine
    : "blanks";

  // Check if the composition is in the appropriate business line favorites
  const businessLineFavorites = window.favorite_composition_ids[businessLineKey] || [];
  const isFavorite = businessLineFavorites.includes(compositionIdInt);

  const heart = productCard.querySelector(SELECTORS.HEART);
  if (!heart) return;

  const isHidden = heart.classList.contains("hidden");

  if (isFavorite && isHidden) {
    heart.classList.remove("hidden");
  } else if (!isFavorite && !isHidden) {
    heart.classList.add("hidden");
  }
};

const shouldHandleShipperClick = eventTarget =>
  !isTouchDevice() &&
  (eventTarget.closest(SELECTORS.SHIPPER) || eventTarget.classList.contains(SELECTORS.SHIPPER));

const handleTooltip = () => {
  $(".js-ships-tooltip")
    .off("inserted.bs.tooltip")
    .on("inserted.bs.tooltip", event => {
      const $$tooltipLink = $(event.currentTarget);
      const tooltipId = $$tooltipLink.attr("aria-describedby");
      const $tooltipElem = document.getElementById(tooltipId);
      const hideTooltip = e => {
        if (
          e.type === "click" &&
          (e.composedPath().includes($tooltipElem) || e.composedPath().includes($$tooltipLink[0]))
        )
          return;

        $tooltipElem.classList.remove("show");
        $$tooltipLink.tooltip("hide");
      };

      if ($tooltipElem.classList.contains("show")) return;

      // Hide other tooltips before showing the current one
      $(".js-ships-tooltip")
        .not($$tooltipLink)
        .each((_, $element) => {
          const $$element = $($element);
          const otherTooltipId = $$element.attr("aria-describedby");
          const $otherTooltipElem = document.getElementById(otherTooltipId);
          if (!$otherTooltipElem) return;

          $otherTooltipElem.classList.remove("show");
          $$element.tooltip("hide");
        });

      $tooltipElem.classList.add("show");
      $$tooltipLink.on("keydown", hideTooltip);
      $tooltipElem.addEventListener("mouseleave", hideTooltip);
      document.addEventListener("scroll", hideTooltip);
      document.addEventListener("click", hideTooltip, true);

      $$tooltipLink.on("hide.bs.tooltip", e => {
        if ($tooltipElem.classList.contains("show")) {
          e.preventDefault();
        } else {
          $$tooltipLink.off("keydown");
          $tooltipElem.removeEventListener("mouseleave", hideTooltip);
          document.removeEventListener("scroll", hideTooltip);
          document.removeEventListener("click", hideTooltip, true);
          $$tooltipLink.off("hide.bs.tooltip");
        }
      });
    });
};

const handleDesignLabCTAClick = (e, $button) => {
  e.preventDefault();
  e.stopPropagation();

  const { catalogNumber, colorName, compositionId } = $button.dataset;

  window.parent.postMessage(
    {
      type: "designlabmodal:productadded",
      payload: {
        catalogId: catalogNumber,
        colorName,
        compositionId,
        replace: isReplaceShirtPage()
      }
    },
    "*"
  );
};

const addReplaceParamToProductCardUrls = productCards => {
  productCards.forEach($productCard => {
    const currentHref = $productCard.getAttribute("href");
    const urlObj = new URL(currentHref, window.location.origin);
    urlObj.searchParams.set("replace", "true");
    $productCard.setAttribute("href", urlObj.toString());
  });
};

export default () => {
  const productCards = document.querySelectorAll(SELECTORS.CARD);

  if (isReplaceShirtPage()) {
    addReplaceParamToProductCardUrls(productCards);

    document.querySelectorAll(".js-plp-design-lab-cta-button-text").forEach($buttonText => {
      $buttonText.textContent = "Select Product";
    });
  }

  productCards.forEach($productCard => {
    initQtyPricingPopover($productCard);

    $productCard.addEventListener("click", e => {
      const { gaLabel: gaEventLabel, badges, name, amount, currency } = $productCard.dataset;
      const $currentQtyPricingPopover = e.target.closest(SELECTORS.QTY_PRICING_POPOVER);
      const $designLabCTAButton = e.target.closest(SELECTORS.DESIGN_LAB_CTA_BUTTON);

      if ($currentQtyPricingPopover) {
        e.preventDefault();
      }

      if ($designLabCTAButton) {
        handleDesignLabCTAClick(e, $designLabCTAButton);
        return;
      }

      const $productItem = $productCard.closest(".js-products__item");
      const { gaList = "" } = $productItem ? $productItem.dataset : {};
      cacheDeliveryEstimate($productCard);

      if (shouldHandleShipperClick(e.target)) {
        const { shipperPath, shipperLabel } = $productCard.querySelector(SELECTORS.SHIPPER).dataset;

        if (shipperPath) {
          sendDataLayer({
            genericEvent: true,
            eventCategory: "shipperclick",
            event: "click",
            eventLabel: shipperLabel
          });

          window.location.href = shipperPath;

          return;
        }
      }

      if (gaEventLabel) {
        const path = gaEventLabel.split(":");
        const catalogNumber = path.pop();
        sendDataLayer({
          event: "SelectItem",
          ecommerce: {
            items: [
              {
                item_id: catalogNumber,
                item_name: name,
                price: amount,
                currency
              }
            ],
            item_list_name: gaList
          }
        });

        sendDataLayer({
          genericEvent: true,
          eventCategory: "productclick",
          event: "click",
          eventLabel: gaEventLabel
        });

        if (badges) {
          JSON.parse(badges).forEach(badgeName => {
            sendDataLayer({
              genericEvent: true,
              eventCategory: "UX",
              event: "Badge Viewed",
              eventLabel: `${gaEventLabel}:${badgeName}`
            });
          });
        }
      }
    });

    handleTooltip();
    displayFavorites($productCard);
  });

  document.querySelectorAll(".product-card__explanation").forEach(explanation => {
    explanation.addEventListener("click", _e => {
      /* eslint-disable no-console */
      console.log(JSON.parse(explanation.dataset.explanation));
      /* eslint-enable no-console */
    });
  });
};
